export const HomeForCardsData = [
    {
        tag: "FOR EMPLOYEES",
        heading: `Track your employees working time`,
        desc: "Log working hours of your employees automatically or manually and make sure they are billed fairly.",
        subHeading: "check logged time on the handy Timesheet",
        subDesc: "Enjoy the transparency - check your employees time records with more detailed information on the handy timesheet or a graphical, calendar-like view.",
        opt1: "Try our easy-to-use desktop app",
        opt2: "Track your activities automatically",
        buttonText: "Track employees time",
        img: "https://cdn-m.timecamp.com/img/greenbranding/features/img-home-features.svg",
        leftImg:false
        
    },
    {
        tag: "FOR MANAGERS",
        heading: `Track project time and budget easier than ever before`,
        desc: "Stay on top of your team’s performance and create accurate resource estimates for all the projects.",
        subHeading: "Ensure project profitability by analyzing reports",
        subDesc: "TimeCamp provides you with all the data you need to analyze the projects’ performance to ensure your team always stays on track. Look at the clear graphics and get a better view of the time tracked!",
        opt1: "Intergrate with other tools for better performance",
        opt2: "Take advantage of simple,accurate budgeting",
        buttonText: "Increase team productivity",
        img: "https://cdn-m.timecamp.com/img/greenbranding/features/reporting-features.svg",
        leftImg:true
        
    },
    {
        tag: "ENTERPRISE",
        heading: `Try enterprise time tracking at the highest level`,
        desc: "Custom needs? No problem! Contact us, and we will definitely find a perfect solution for your enterprise.",
        subHeading: "Transfer multilevel project structures",
        subDesc: "No matter how many projects your team is currently working on, with TimeCamp you'll be able to organize work time without any problem.",
        opt1: "Achieve full compliance with data regulations",
        opt2: "Get help from our Customer with data regulations",
        buttonText: "Contact for customized solution",
        img: "https://cdn-m.timecamp.com/img/greenbranding/features/project-structure.svg",
        leftImg:false
        
    },
    {
        tag: "FOR HR",
        heading: `Check Timesheets and control attendance in one place`,
        desc: "With TimeCamp you can forget about endless stacks of papers! Take advantage of convenient and easy to use tools to support your daily HR and payroll work.",
        subHeading: "Track attendance automatically",
        subDesc: "TimeCamp allows both you and your employees to keep an eye on their absence, sick days, or vacation leaves. Track attendance and working hours easily as never before.",
        opt1: "Check and approve employees Timesheets",
        opt2: "Intergrate with payroll tools to work faster",
        buttonText: "Make HR's work easier",
        img: "https://cdn-m.timecamp.com/img/greenbranding/features/attendance-features.svg",
        leftImg:true
    }

]